import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { QrCodeData } from 'src/app/interfaces/qr-code';
import { ProductLevel } from 'src/app/shared/components/subscription-pages/product-hero/product-hero.component';
import { QrCodeService } from 'src/app/services/qr-code/qr-code.service';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { QrCodeLocationModalComponent } from 'src/app/modals/qr-code-location-modal/qr-code-location-modal.component';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';

@Component({
  selector: 'app-qr-code-page',
  templateUrl: './qr-code-page.component.html',
  styleUrls: ['./qr-code-page.component.scss'],
})
export class QrCodePageComponent implements OnInit, AfterViewInit {
  qrCodeData: QrCodeData;
  public keeperDataProvided: boolean = false;
  public petDataProvided: boolean = false;
  public productLevels = ProductLevel;
  petImage: string;

  qrCodeLocationModalRef?: NgbModalRef;

  isPreview: boolean = true;

  queryParams: Params;
  petId: number;

  constructor(
    private route: ActivatedRoute,
    private service: QrCodeService,
    private modalService: NgbModal,
    private cloudinaryService: CloudinaryService
  ) {
    this.qrCodeData = this.route.snapshot.data.qrCodeData as QrCodeData;
    this.keeperDataProvided =
      !!this.qrCodeData.keeperAddress ||
      !!this.qrCodeData.keeperEmail ||
      !!this.qrCodeData.keeperName ||
      !!this.qrCodeData.keeperPhone;

    this.petDataProvided =
      !!this.qrCodeData.petName ||
      !!this.qrCodeData.petBirthDate ||
      !!this.qrCodeData.petGender ||
      !!this.qrCodeData.petBreed ||
      !!this.qrCodeData.petSpecies ||
      !!this.qrCodeData.petNeutered ||
      !!this.qrCodeData.petExistingConditions ||
      !!this.qrCodeData.petImageId;

    this.queryParams = this.route.snapshot.queryParams;
    this.petId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    if (!this.queryParams || (this.queryParams && !this.queryParams.preview)) {
      this.isPreview = false;
    }

    this.petImage = this.getPetImageUrl(this.qrCodeData.petImageId);
  }

  ngAfterViewInit() {
    const snapshot = this.route.snapshot;
    const isPreview = snapshot.queryParams.preview === 'true';
    if (isPreview) return;
    const modalOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
    };

    this.qrCodeLocationModalRef = this.modalService.open(
      QrCodeLocationModalComponent,
      modalOptions
    );
    const { id } = this.route.snapshot.params;

    this.qrCodeLocationModalRef.componentInstance.id = id;
    this.qrCodeLocationModalRef.componentInstance.isPreview = this.isPreview;
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 360, 360, null);
  }
}
